import { Injectable } from '@angular/core';
// import { ApplicationUser } from '../viewmodels/application-user';
import { Router } from '@angular/router';
// import { AuthenticationObserver } from './authentication.observer';
// import { Observable } from 'rxjs/';
// import { AuthenticationResult } from '../viewmodels/authetication-result';

import { Constants } from '../../shared/common/helper/constants';
import { HttpService } from '../../shared/common/helper/httpService';
import { Observable } from 'rxjs';
// import * as moment from 'moment';
// import { NonDynamicSettingsViewModel } from '../viewmodels/non-dynamic-settings-viewmodel';

@Injectable()
export class SettingsService {
  private settingsServiceUrl = Constants.serverUrl + 'api/configuration/';

  constructor(
    public http: HttpService,
    private router: Router
  ) {}

  // getCouncilLogo() : Observable<any> {
  //  return this.http.get(this.settingsServiceUrl + 'getCouncilLogo')
  //    .map((res: Response) => res.json());
  // }

  /// ** getSettings */
  // getSettings(): Observable<any> {
  //  return this.http.get(this.settingsServiceUrl + 'getAppSettings')
  //    .map((res: Response) => res.json());
  // }

  /// ** set local appSettings */
  // setLocalAppSettings(appSettings) {
  //  localStorage.setItem('rm_app_settings', JSON.stringify(appSettings));
  // }

  /// ** get local appSettings */
  // getLocalAppSettings(): any {
  //  return localStorage.getItem('rm_app_settings') ?
  //    JSON.parse(localStorage.getItem('rm_app_settings')) : [];
  // }

  getNonDynamicSettings(): Observable<any> {
    return this.http.Get(this.settingsServiceUrl + 'getNonDynamicSettings');
  }

  getApplicationSetting(key: string): any {
    const data = JSON.stringify(key);
    return this.http.Post(this.settingsServiceUrl + 'getApplicationSetting', data);
  }

  updateAppSetting(identifier: string, value: string): any {
    const url =
      this.settingsServiceUrl +
      `updateAppSetting?identifier=${encodeURIComponent(identifier)}&value=${encodeURIComponent(value)}`;
    return this.http.Post(url, null);
  }
  // /** set local debugConsole */
  // setLocalDebugConsole(isEnable) {
  //   localStorage.setItem('rm_app_debug_console', JSON.stringify(isEnable));
  // }

  // /** get local debugConsole */
  // getLocalDebugConsole(): any {
  //   return localStorage.getItem('rm_app_debug_console') ?
  //     JSON.parse(localStorage.getItem('rm_app_debug_console')) : 'false';
  // }

  // /** update enable debug console to cache */
  // updateEnableDebugConsole(newValue) {
  //   // let appSettings = this.getLocalAppSettings();
  //   // appSettings['Configuration.EnableDebugConsole'] = newValue;
  //   // this.setLocalAppSettings(appSettings);
  //   localStorage.setItem('rm_app_debug_console', JSON.stringify(newValue));
  // }

  /** add council image to cache */
  // addCouncilImageToCache(code) {
  //  let appSettings = this.getLocalAppSettings();
  //  appSettings['Council.Logo'] = code;
  //  this.setLocalAppSettings(appSettings);
  // }
}
